function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { mutateContentValue } from '@truqc/content-path';
import constants from '../constants/formModalConstants';
import applyReducer from './applyReducer';
import changeReducerFactory from './factories/changeReducerFactory';
import contentChangeReducerFactory from './factories/contentChangeReducerFactory';
import uploadReducerFactory from './factories/uploadReducerFactory';
const changeReducer = changeReducerFactory('formModal', 'forms');
const contentChangeReducer = contentChangeReducerFactory('formModal', 'forms');
const uploadReducer = uploadReducerFactory('formModal', 'forms');
const initState = _objectSpread({
  open: false,
  active: null,
  activeCache: null
}, uploadReducer.initState);
const close = state => _objectSpread(_objectSpread({}, state), initState);
const open = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  open: true
}, action.payload);
const setEditorCacheValue = (state, {
  name,
  value
}) => {
  const editorCache = state.editorCache || {};
  mutateContentValue(name, editorCache, value);
  return _objectSpread(_objectSpread({}, state), {}, {
    editorCache
  });
};

/**
 *  'deferred' is just a special case of 'form' used by formSearchField. When a deferred form
 *  loads successfully, cache the record in the primary form.editorCache.
 *
 *  Note that the deferred form does not contain all the content data, just the id and title.
 *  More sophisticated loading may be required in the future.
 */
const setEditorCacheValueFromDeferred = (state, action) => {
  const {
    id,
    content = {}
  } = action;
  return setEditorCacheValue(state, {
    name: `formCache/${id}`,
    value: content
  });
};
const reducers = _objectSpread(_objectSpread(_objectSpread({
  [constants.OPEN]: open,
  [constants.CLOSE]: close,
  [constants.SET_EDITOR_CACHE_VALUE]: setEditorCacheValue,
  [constants.SET_EDITOR_CACHE_VALUE_FROM_DEFERRED]: setEditorCacheValueFromDeferred
}, uploadReducer.reducers), changeReducer.reducers), contentChangeReducer.reducers);
export default applyReducer(reducers, initState);